var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.51 60.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c33539;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.17,
    cy: 33.03,
    r: 18.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.04,26.69l-4.13-4.13c-.98-.98-1.78-2.92-1.78-4.3v-5.84c0-2.78-2.27-5.04-5.04-5.05h-5.84c-1.39,0-3.32-.8-4.3-1.78l-4.13-4.13c-1.96-1.96-5.17-1.96-7.13,0l-4.13,4.13c-.98.98-2.92,1.78-4.3,1.78h-5.84c-2.77,0-5.04,2.27-5.04,5.04v5.84c0,1.38-.8,3.32-1.78,4.3l-4.13,4.13c-1.96,1.96-1.96,5.17,0,7.13l4.13,4.13c.98.98,1.78,2.92,1.78,4.3v5.84c0,2.77,2.27,5.04,5.04,5.04h5.84c1.39,0,3.32.8,4.3,1.78l4.13,4.13c1.96,1.96,5.17,1.96,7.13,0l4.13-4.13c.98-.98,2.92-1.78,4.3-1.78h5.84c2.78,0,5.04-2.27,5.04-5.04v-5.84c0-1.39.8-3.32,1.78-4.3l4.13-4.13c1.96-1.96,1.96-5.17,0-7.13ZM26.25,41.6l-11.13-11.13,3.57-3.56,7.56,7.56,15.56-15.56,3.56,3.56-19.13,19.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.0da7d1f48e6260af1b0466abd97e42d6.svg";
export { ForwardRef as ReactComponent };